/**
 * Date utilities anchored in America/Sao_Paulo, whatever zone the browser is in.
 *
 * That anchor is what keeps a user ahead of Brazil from picking a date their clock calls tomorrow
 * while the server still calls it today. Raw `new Date()` arithmetic reintroduces exactly that bug.
 *
 * @see docs/architecture-standards.md
 */

const BRAZIL_TIMEZONE = "America/Sao_Paulo";

/** Today's date in Brazil as yyyy-MM-dd string. */
export function getTodayInBrazil(): string {
  return new Intl.DateTimeFormat("sv-SE", { timeZone: BRAZIL_TIMEZONE }).format(new Date());
}

/**
 * Today's date in Brazil as a Date object — the `minDate` of a field that may still name today,
 * such as the date of a list whose party is tonight.
 */
export function startOfTodayInBrazil(): Date {
  const [year, month, day] = getTodayInBrazil().split("-").map(Number);

  return new Date(year, month - 1, day);
}

/**
 * Tomorrow's date in Brazil as a Date object — for use as `minDate` in
 * DatePicker components. The Date is at midnight UTC of the Brazil-tomorrow,
 * which is safe for date-only comparisons in the picker.
 */
export function getTomorrowInBrazil(): Date {
  const today = startOfTodayInBrazil();
  today.setDate(today.getDate() + 1);

  return today;
}
